import { z } from 'zod';
import { isoDateSchema } from './day';

// Why a booking was refused, in a word the screen can translate. A message in
// the server's own English is no use in a Greek-first UI. §15, §19
export const BOOKING_PROBLEMS = ['spot-booked', 'spot-in-checkout'] as const;

export const bookingProblemSchema = z.object({
  reason: z.enum(BOOKING_PROBLEMS),
  spotNumbers: z.array(z.number().int().positive()).min(1),
  // Which days of the range are taken; "those days" is no use to anyone. §10
  days: z.array(isoDateSchema).default([]),
});

export type BookingProblem = z.infer<typeof bookingProblemSchema>;

// A spot a checkout is paying for is not booked: it frees itself if nobody
// pays, and saying "already booked" of it is simply untrue. §13
export function bookingProblemOf(
  clashing: 'pending' | 'active',
  spotNumber: number,
  days: readonly string[] = [],
) {
  return {
    reason: clashing === 'pending' ? ('spot-in-checkout' as const) : ('spot-booked' as const),
    spotNumbers: [spotNumber],
    days: [...days],
  };
}

export function readBookingProblem(body: unknown): BookingProblem | null {
  const parsed = bookingProblemSchema.safeParse(body);
  return parsed.success ? parsed.data : null;
}
